import type { FaireProductEntity } from "../../entity_types/product";

export const p_keqgr868p3: FaireProductEntity = {
  token: "p_keqgr868p3",
  type: "product",
  name: "Structured Blazer and Slit Skirt Set – Women’s Tailored Two-Piece Suit",
  brandToken: "b_mdfcwdnw57",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/662de6190afb3fcfc422b8f3f48998c68aef479e254e0f82514f8d95d99b3393.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/692018f63465b9039981844d49c24ae820d2112ccfbaaefacc2ccb7ced4d2892.jpeg",
    "https://cdn.faire.com/fastly/39955d4bfb5f7be28e62a1d4683406977821aa3d673f63890367b05b6dcd30c0.jpeg",
    "https://cdn.faire.com/fastly/d59101b8aea9e9e0dd284f99f368aafb40cd79b3d0f3902799e21d8d3f680b92.jpeg",
    "https://cdn.faire.com/fastly/887ea79f8b98938e5008d014dcfbff08855be6a70275b4ba75efedca37c06e85.jpeg",
    "https://cdn.faire.com/fastly/3d37a91c59b7a6976ad9043150f18fd9845e0665bd32a437fbe838a967039fc4.jpeg",
    "https://cdn.faire.com/fastly/d50a9b2b3252d0fe29e5f6b3b1afb9d1b137dc1cf13eb6529bc2fc630ceab52a.jpeg",
    "https://cdn.faire.com/fastly/c457e93e2d76c2e5923fe4d653aad7e380b5690d95d6ee97c8e97766dd903289.jpeg",
    "https://cdn.faire.com/fastly/be053d7ac163a41680de990c522f40cb07cede69d7848a64ab4b2e0b93b6ee9f.jpeg",
    "https://cdn.faire.com/fastly/e3a1c131801a3fa9d921b9e5f8931ea96e903050012a1a909a2932fbf6f0c51a.jpeg",
    "https://cdn.faire.com/fastly/8a565b299b925ce44bccdd87c7e70405af04afa92eb7579d8f543568f0072c4c.jpeg",
  ],
  priceDollars: 67.89,
  description:
    "Structured Blazer and Slit Skirt Set delivers sharp tailoring and a modern silhouette for work or evening events. Made from a premium fabric blend of 78% polyester, 17% viscose, and 5% spandex, this two-piece set offers a smooth feel with slight stretch for comfortable movement. The single-breasted blazer features padded shoulders, peaked lapels, and flap pockets, while the high-waist skirt stands out with a sleek front slit for a contemporary edge.\n\n\n\n\nSize details:\n\nBlazer\n\n * \nS: Shoulder 44 cm / 17.3 in, Bust 100 cm / 39.4 in, Sleeve 60 cm / 23.6 in, Length 75 cm / 29.5 in\n\n * \nM: Shoulder 45 cm / 17.7 in, Bust 104 cm / 40.9 in, Sleeve 61 cm / 24 in, Length 76 cm / 29.9 in\n\n * \nL: Shoulder 46 cm / 18.1 in, Bust 108 cm / 42.5 in, Sleeve 62 cm / 24.4 in, Length 77 cm / 30.3 in\n\n\n\nSkirt\n\n * \nS: Waist 68 cm / 26.8 in, Hip 98 cm / 38.6 in, Length 93 cm / 36.6 in\n\n * \nM: Waist 72 cm / 28.3 in, Hip 102 cm / 40.2 in, Length 94 cm / 37 in\n\n * \nL: Waist 76 cm / 29.9 in, Hip 106 cm / 41.7 in, Length 95 cm / 37.4 in\n\n\n\nPair with heels and a structured handbag for a standout look from office hours to evening plans.\n",
  tags: [],
  msrpDollars: 135.78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:58.925Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
